import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum FontanelsEnum {
    Anterior = 1 as any,
    Posterior = 2 as any
}
class FontanelsClass extends EnumWithDescription<FontanelsEnum> {
    public readonly enum = FontanelsEnum;
    public readonly enumName: string = "FontanelsEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<FontanelsEnum>> = new Map([
        [
            "Anterior",
            {
                value: FontanelsEnum.Anterior,
                name: "Anterior"
            }
        ],
        [
            "Posterior",
            {
                value: FontanelsEnum.Posterior,
                name: "Posterior"
            }
        ]
    ]);
}

export const Fontanels = new FontanelsClass();
